import React from "react"
import PropTypes from "prop-types"
import L10n from "lib/carrot-l10n"
import WidgetWrapper from "components/views/widgets/WidgetWrapper"
import { Spacer } from "components/views/atoms/Atoms"
import { Button } from "components/views/atoms/buttons/Button"
import { ButtonPrimary } from "components/views/atoms/buttons/ButtonPrimary"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

/** @deprecated */
const WizardWrapper = ({
  back,
  backRoute,
  children,
  done,
  doneRoute,
  nextDisabled,
  onDone,
  sending,
  title,
  contentWidth,
  nextId = "",
  backText = l`back`,
  doneText = l`done`,
  sendingText = l`client.sending`
}) => {
  const handleSubmit = (event) => {
    event.preventDefault()
    if (!nextDisabled && !sending) {
      onDone()
    }
  }
  return (
    <WidgetWrapper narrow title={title}>
      <form onSubmit={handleSubmit}>
        <div className={contentWidth}>
          {children}
          <Spacer height={0.5} />
          <div className="flex flex-row justify-end">
            {back && (
              <div className="mr3">
                <Button to={backRoute} enabled={!sending} outline>
                  <div className="min-w3 tc">{backText}</div>
                </Button>
              </div>
            )}
            {done && (
              <ButtonPrimary to={doneRoute} id={nextId} enabled={!sending && !nextDisabled} onClick={handleSubmit}>
                <div className="min-w3 tc">{sending ? sendingText : doneText}</div>
              </ButtonPrimary>
            )}
          </div>
        </div>
      </form>
    </WidgetWrapper>
  )
}

WizardWrapper.propTypes = {
  back: PropTypes.bool,
  backRoute: PropTypes.string,
  backText: PropTypes.string,
  done: PropTypes.bool,
  doneRoute: PropTypes.string,
  doneText: PropTypes.string,
  onDone: PropTypes.func,
  sending: PropTypes.bool,
  sendingText: PropTypes.string,
  title: PropTypes.string,
  contentWidth: PropTypes.string,
  nextDisabled: PropTypes.bool
}

export default WizardWrapper
